import { Component, Input } from '@angular/core';
import { ClientService } from '../../core/services/client.service';
import { ActivatedRoute } from '@angular/router';
import { IntlService } from '../../core/services/intl.service';
import { NgIf } from '@angular/common';
import { ClientConfirmComponent } from '../client-confirm/client-confirm.component';
import { ClientSuccessComponent } from '../client-success/client-success.component';
import { AlertComponent } from '../../shared-with-client/alert/alert.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-client-pay-booking',
    templateUrl: './client-pay-booking.component.html',
    styleUrls: ['./client-pay-booking.component.scss'],
    imports: [NgIf, ClientConfirmComponent, ClientSuccessComponent, AlertComponent, TranslatePipe],
    standalone: true
})
export class ClientPayBookingComponent {

  @Input() merchant;

  public errorMsg;
  public loading;
  public submitAttempted = false;
  public bookingId;
  public bookingCode;
  public booking;
  public deleted = false;
  public day;
  public time;
  public currentPage = 0;
  public finalBooking;
  public services;
  public providers;

  formatTime: string;

  constructor(private clientService: ClientService,
    private activatedRoute: ActivatedRoute,
    private intlService: IntlService,
    ) { }

  ngOnInit() {
    this.formatTime = this.intlService.getTimeFormatShort();
    this.bookingId = this.activatedRoute.snapshot.params.bookingId;
    this.bookingCode = this.activatedRoute.snapshot.params.bookingCode;

    this.loading = true;
    this.clientService.getBooking(this.bookingId, this.bookingCode).subscribe(res => {
      this.booking = res;
      this.services = [this.booking.service];
      this.providers = [this.booking.provider];

      if (this.booking.multipleBookings) {
        this.services = this.booking.multipleBookings.map(booking => booking.service);
        this.providers = this.booking.multipleBookings.map(booking => booking.provider);
      }

      this.day = {day: this.booking.dateInit.substring(0, 10)};
      this.time = {start: this.booking.dateInit.substring(11, 16), end: this.booking.dateEnd.substring(11, 16)};
      this.loading = false;
    }, err => {
      if (err.errMsg === 'Not found Booking') {
        this.deleted = true;
        this.loading = false;
      } else {
        this.errorMsg = err.errMsg;
        this.loading = false;
      }
    });
  }
}
